import React from "react";
import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { RISK_CHART_COLORS } from "../../utils/actionCardColors";
import { rectCheckboxProps } from "./RectCheckbox";

const IncidentChartOptions = ({
  t,
  isGentofteLife,
  showMinInjuries,
  setShowMinInjuries,
  showRealIncident,
  setShowRealIncident,
  showTraining,
  setShowTraining,
  showRead,
  setShowRead,
  showNull,
  setShowNull,
  showIncidentYellow,
  setShowIncidentYellow,
  showIncidentRed,
  setShowIncidentRed,
}) => (
  <Box className="risk-chart-options">
    <Box className="risk-chart-options-group">
      <Typography className="risk-chart-options-title">Risk filter</Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={showMinInjuries}
            onChange={() => setShowMinInjuries((value) => !value)}
            size="small"
            {...rectCheckboxProps(RISK_CHART_COLORS.red)}
            sx={{
              color: RISK_CHART_COLORS.red,
              "&.Mui-checked": { color: RISK_CHART_COLORS.red },
            }}
          />
        }
        label={
          <Typography variant="body2" color={RISK_CHART_COLORS.red}>
            Min. injuries
          </Typography>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={showRealIncident}
            onChange={() => setShowRealIncident((value) => !value)}
            size="small"
            {...rectCheckboxProps(RISK_CHART_COLORS.default)}
          />
        }
        label={t("faktuel")}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={showTraining}
            onChange={() => setShowTraining((value) => !value)}
            size="small"
            {...rectCheckboxProps(RISK_CHART_COLORS.training)}
          />
        }
        label={t("training").replace(/^View\s+/i, "")}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={showRead}
            onChange={() => setShowRead((value) => !value)}
            size="small"
            {...rectCheckboxProps(RISK_CHART_COLORS.reading)}
          />
        }
        label={t("read").replace(/^View\s+/i, "")}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={showNull}
            onChange={() => setShowNull((value) => !value)}
            size="small"
            {...rectCheckboxProps("#cfcfcf")}
          />
        }
        label={t("see_null_data")}
      />
      {isGentofteLife ? (
        <>
          <Typography variant="body2" fontWeight={600} sx={{ mt: 1 }}>
            {t("incidentType")}
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={showRealIncident && showIncidentYellow}
                disabled={!showRealIncident}
                onChange={() => setShowIncidentYellow((v) => !v)}
                size="small"
                {...rectCheckboxProps(RISK_CHART_COLORS.yellow)}
              />
            }
            label={t("yellow")}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={showRealIncident && showIncidentRed}
                disabled={!showRealIncident}
                onChange={() => setShowIncidentRed((v) => !v)}
                size="small"
                {...rectCheckboxProps(RISK_CHART_COLORS.red)}
              />
            }
            label={t("red")}
          />
        </>
      ) : null}
    </Box>
  </Box>
);

export default IncidentChartOptions;
